import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, Group } from "@mantine/core";
import { useParams } from "react-router-dom";

import { ErrorView, PageTitle } from "@components/shared";
import { QuestionForm } from "@components/Question";

import entityIcon from "@util/entityIcon";
import entityColor from "@util/entityColor";

import { question as dummyQuestion } from "@dummy/question";

export default function QuestionDetail() {
  const [error, setError] = useState(null);
  const [question, setQuestion] = useState(null);
  const params = useParams();
  const { id } = params;

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios
      .get(`/questions/${id}/`)
      .then(({ data }) => {
        setQuestion(data.response[0]);
      })
      .catch((err) => {
        // setError(err);
        setQuestion(dummyQuestion);
      });
  }

  if (error) {
    return <ErrorView text={error} />;
  }

  if (!question) return null;

  return (
    <div>
      <PageTitle
        title={`${question.text}`}
        subtitle={`Question created on ${new Date(
          question.created_at
        ).toLocaleString()}`}
        icon={entityIcon.question()}
        iconColor={entityColor.question}
      />
      <Card mt="md">
        {JSON.stringify(question)}
        {/* <QuestionForm
          id={id}
          question={question.question}
          onSuccess={fetchData}
        /> */}
      </Card>
    </div>
  );
}
